import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import store from './store/store'
import vuetify from './plugins/vuetify'
import VueTour from 'vue-tour'

Vue.config.productionTip = false

Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
